module.exports = __webpack_public_path__ + "static/Img_pledge_graph_02@2x-e09496fd23d020b7b0617ad488aebbaa.png";